const X_OFFSET_PX = 16
const Y_OFFSET_PX = 8

export function calculateVerticalPosition(triggerRect, menuRect) {
  const viewportHeight = window.innerHeight
  const spaceBelow = viewportHeight - triggerRect.bottom
  const spaceAbove = triggerRect.top
  const menuHeight = menuRect.height

  if (spaceBelow >= menuHeight + Y_OFFSET_PX) {
    return triggerRect.bottom + Y_OFFSET_PX
  } else if (spaceAbove >= menuHeight + Y_OFFSET_PX) {
    return triggerRect.top - menuHeight - Y_OFFSET_PX
  } else {
    return Math.max(Y_OFFSET_PX, viewportHeight - menuHeight - Y_OFFSET_PX)
  }
}

export function calculateHorizontalPosition(initialLeft, menuRect) {
  const viewportWidth = window.innerWidth
  const menuWidth = menuRect.width

  if (initialLeft + menuWidth > viewportWidth) {
    return Math.max(X_OFFSET_PX, viewportWidth - menuWidth - X_OFFSET_PX)
  }

  return Math.max(X_OFFSET_PX, initialLeft)
}

export function applyMenuPosition(menuElement, top, left) {
  menuElement.style.position = "fixed"
  menuElement.style.top = `${top}px`
  menuElement.style.left = `${left}px`
}
